// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
}

button {
  background: none;
  outline: none;
  margin: 0;
  border: none;
  cursor: pointer;
  color: inherit;
}

a {
  color: black;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/library/style/reset.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B","sourcesContent":["body {\r\n  margin: 0;\r\n}\r\n\r\nbutton {\r\n  background: none;\r\n  outline: none;\r\n  margin: 0;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: inherit;\r\n}\r\n\r\na {\r\n  color: black;\r\n  text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
